import { render, staticRenderFns } from "./peixun.vue?vue&type=template&id=e1d5e912&"
import script from "./peixun.vue?vue&type=script&lang=js&"
export * from "./peixun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports